import React, { useState, useEffect } from 'react';
import Portal from '../common/Portal';
import CustomSelect from '../common/CustomSelect';

const AllocateFeedModal = ({ isOpen, onClose, onSubmit, isLoading, feedInventory }) => {
    const [allocationData, setAllocationData] = useState({ feedItemId: '', quantity: '' });

    // Reset the form every time the modal is opened
    useEffect(() => {
        if (isOpen) {
            setAllocationData({ feedItemId: '', quantity: '' });
        }
    }, [isOpen]);
    
    if (!isOpen) return null;

    // --- Handlers ---
    const handleChange = (e) => setAllocationData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    
    const handleFeedItemChange = (selectedValue) => {
        setAllocationData(prev => ({ ...prev, feedItemId: selectedValue }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!allocationData.feedItemId || !allocationData.quantity) {
            console.error("Please select a feed item and enter a quantity.");
            return;
        }
        onSubmit(allocationData);
    };

    // --- Data for CustomSelect ---
    // The CustomSelect component needs the data in a specific format
    const feedOptions = feedInventory.map(item => ({
        id: item.id,
        name: `${item.name} (${item.stock.toFixed(2)} kg available)`,
        value: item.id,
        disabled: item.stock <= 0 // Headless UI can't disable options, but you can filter them out if needed
    }));

    return (
        <Portal>
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                <div className="bg-white rounded-lg shadow-xl p-8 w-full max-w-md m-4">
                    <h2 className="text-2xl font-bold mb-6 text-gray-800">Allocate Feed</h2>
                    <form onSubmit={handleSubmit}>
                        <div className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Feed Type</label>
                                <CustomSelect
                                    options={feedOptions}
                                    selected={allocationData.feedItemId}
                                    onChange={handleFeedItemChange}
                                    placeholder="Select a feed..."
                                />
                            </div>
                            <div>
                                <label htmlFor="quantity" className="block text-sm font-medium text-gray-700">Quantity (kg)</label>
                                <input 
                                    type="number" 
                                    step="0.1" 
                                    name="quantity" 
                                    id="quantity" 
                                    value={allocationData.quantity} 
                                    onChange={handleChange} 
                                    className="mt-1 block w-full form-input rounded-md shadow-sm" 
                                    required 
                                />
                            </div>
                        </div>
                        <div className="mt-8 flex justify-end space-x-3">
                            <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300">Cancel</button>
                            <button type="submit" disabled={isLoading} className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 disabled:bg-green-300 flex items-center">
                                {isLoading && <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>}
                                {isLoading ? 'Allocating...' : 'Allocate'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Portal>
    );
};

export default AllocateFeedModal;